<template>
  <div id="app" :class="{ 'header-margin': isProduction === 'production' }">
    <div class="wrapper">
      <section id="kv" class="kv-container section">
        <div class="content-box">
          <div class="main-title">LF-ZC</div>
          <p class="text pc">
            LF-ZC 的名稱，取自 Lexus Future Zero-emission Catalyst 的縮寫<br>
            寓意 Lexus 通往未來、零汙染世界的重要過程<br>
            也呼應了Lexus 宣告於 2035 年實現全面電動化的決心
          </p>
          <p class="text mb">
            LF-ZC 的名稱<br>
            擷取自 Lexus Future Zero-emission Catalyst 的縮寫<br>
            寓意 Lexus 通往未來、零汙染世界的重要過程<br>
            也呼應了Lexus 宣告於 2035 年實現全面電動化的決心
          </p>
        </div>
      </section>
      <section id="concept" class="concept-container section" :class="{ active: sectionIdObj.concept }">
        <div class="content-box">
          <div class="title">從新角度出發 探索無限可能</div>
          <p class="text pc">俐落前衛的車身雕琢，散發著宛如來自科幻世界的氣息<br>
            以竹子生長快速、環保、可循環使用為發想， 導入 Bamboo CMF (Color, Material, Finish) 的設計概念<br>
            體現通往未來的潔淨動力技術，引領品牌與整個移動概念前往更美麗燦爛的境地
          </p>
          <p class="text mb">
            俐落前衛的車身雕琢，散發著宛如來自科幻世界的氣息<br>
            以竹子生長快速、環保、可循環使用為發想<br>
            導入 Bamboo CMF (Color, Material, Finish) 的設計概念<br>
            體現通往未來的潔淨動力技術<br>
            引領品牌與整個移動概念前往更美麗燦爛的境地
          </p>
        </div>
      </section>
      <section id="tech" class="tech-container section" :class="{ active: sectionIdObj.tech }">
        <div class="content-box">
          <div class="title">明日科技 今日實現 <br>重新定義未來駕馭</div>
          <p class="text pc">
            LF-ZC 導入智慧化底盤與驅動系統<br>
            可隨時依照駕駛喜好、道路環境需求而調整運作特性，兼顧性能與潔淨表現<br>
            搭配最前端 AI 技術，能以自然、宛如朋友的方式與駕駛對談<br>
            也可提供路況、導航等訊息，讓移動過程更加輕鬆自在
          </p>
          <p class="text mb">
            俐落前衛的車身雕琢，散發著宛如來自科幻世界的氣息<br>
            以竹子生長快速、環保、可循環使用為發想<br>
            導入 Bamboo CMF (Color, Material, Finish) 的設計概念<br>
            體現通往未來的潔淨動力技術<br>
            引領品牌與整個移動概念前往更美麗燦爛的境地
          </p>
        </div>
      </section>
      <section id="gallery" class="gallery-container section" :class="{ active: sectionIdObj.gallery }">
        <div class="content-box">
          <div class="title">GALLERY</div>
          <p class="text">張揚大膽之姿 盡顯未來超跑魅力</p>
          <gallerySwiper></gallerySwiper>
        </div>
      </section>
      <!-- <section id="promotion" class="promotion-container section">
        <div
          class="video-wrap"
          @mouseenter="isControllerHide = false"
          @mouseleave="isControllerHide = true"
        >
          <video
            ref="promotionVideo"
            playsinline
            poster="./assets/img/video_poster.png"
            @playing="startedPlaying"
            @onpause="paused"
            @ended="end"
            @canplay="getDuration"
            @timeupdate="getCurrntTime"
            @clcik="isControllerHide = true"
          >
            <source src="video/promotion_final_video.mp4" type="video/mp4" />
          </video>
          <a
            href="javascript:;"
            class="reply-btn"
            @click.prevent="playVideo"
            v-if="isPause"
          ></a>
          <a
            href="javascript:;"
            class="first-play-btn"
            @click.prevent="playVideo"
            v-if="isFirstPlay"
          ></a>
          <div class="bottom-controller" :class="{ hide: isControllerHide }">
            <div class="btn-group">
              <a
                href="javascript:;"
                class="play-btn"
                @click.prevent="playVideo"
              ></a>
              <a
                href="javascript:;"
                class="pause-btn"
                @click.prevent="pauseVideo"
              ></a>
            </div>
            <div class="time-group">
              <div class="current-time">{{ currentTime }}/</div>
              <div class="duration">
                {{ durationTime }}
              </div>
            </div>
          </div>
        </div>
      </section> -->
      <!-- <section
        id="social"
        class="social-container section"
        :class="{ active: sectionIdObj.social }"
      >
        <div class="social-media-wrap">
          <a
            :href="shareUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="social-content"
          >
            <img src="./assets/img/social_share_icon.png" alt="" />
            <div class="social-text">分享至 <br />Facebook</div>
          </a>
          <a
            href="https://www.facebook.com/lexus.tw"
            target="_blank"
            rel="noopener noreferrer"
            class="social-content"
          >
            <img src="./assets/img/social_fb_icon.png" alt="" />
            <div class="social-text">前往 Lexus TW <br />Facebook</div>
          </a>
          <a
            href="https://www.instagram.com/lexus_taiwan/"
            target="_blank"
            rel="noopener noreferrer"
            class="social-content"
          >
            <img src="./assets/img/social_ig_icon.png" alt="" />
            <div class="social-text">前往 Lexus TW <br />Instagram</div>
          </a>
        </div>
      </section> -->
    </div>
  </div>
</template>

<script>
import gallerySwiper from "./component/gallerySwiper";
// import { useIntersectionObserver } from '@vueuse/core'
export default {
  name: "App",
  data() {
    return {
      isProduction: process.env.NODE_ENV,
      sectionIdObj: {
        kv: false,
        concept: false,
        gallery: false,
        tech: false,
        social: false,
      },
      durationTime: "",
      currentTime: "00:00",
      isFirstPlay: true,
      isPause: false,
      isControllerHide: false,
    };
  },
  components: {
    gallerySwiper,
  },
  methods: {
    startedPlaying() {
      console.log("playing");
    },
    paused() {
      console.log("pause");
    },
    end() {
      console.log("end");
      this.isPause = true;
    },
    playVideo() {
      this.$refs.promotionVideo.play();
      this.isFirstPlay = false;
      this.isPause = false;
      this.isControllerHide = true;
    },
    pauseVideo() {
      this.$refs.promotionVideo.pause();
      this.isControllerHide = false;
      // if (this.currentTime !== '00:00') {
      //   this.isPause = true;
      // }
      // console.log(this.$refs.promotionVideo.currentTime);
    },
    getDuration() {
      let seconds = Math.round(this.$refs.promotionVideo.duration);
      let min =
        Math.floor(seconds / 60) >= 10
          ? Math.floor(seconds / 60)
          : "0" + Math.floor(seconds / 60);
      let sec = seconds >= 10 ? seconds : "0" + seconds;
      this.durationTime = min + ":" + sec;
    },
    getCurrntTime() {
      let seconds = Math.round(this.$refs.promotionVideo.currentTime);
      let min =
        Math.floor(seconds / 60) >= 10
          ? Math.floor(seconds / 60)
          : "0" + Math.floor(seconds / 60);
      let sec = seconds >= 10 ? seconds : "0" + seconds;
      this.currentTime = min + ":" + sec;
    },
  },
  mounted() {
    const self = this;
    let sectionList = document.querySelectorAll("section");
    let io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (el) {
          if (el.isIntersecting) {
            self.sectionIdObj[el.target.id] = true;
          }
        });
      },
      {
        threshold: [0.25],
      }
    );
    sectionList.forEach(function (el) {
      io.observe(el);
    });
    // console.log(this.$refs.promotionVideo.duration);
  },
  computed: {
    shareUrl() {
      return `https://www.facebook.com/sharer.php?u=${process.env.VUE_APP_SITE}`;
    },
    // durationTime(){
    //   if(this.$refs.promotionVideo.duration){
    //     return this.$refs.promotionVideo.duration
    //   }
    //   else{
    //     return "00:00"
    //   }
    // }
  },
};
</script>

<style lang="scss">
body {
  font: unset;
}

#app {
  font-family: "nbk", $fontFamilyNotoSans;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  a:hover {
    text-decoration: none;
  }
}

.section {
  min-height: vwX(860);

  @include tablet {
    min-height: vw(1100);
  }
}

.main-title {
  font-size: vwX(96);
  letter-spacing: vwX(PsdLetterSpacing(20, 96));
  margin-bottom: vwX(15);

  @include tablet {
    font-size: vw(56);
    letter-spacing: vw(PsdLetterSpacing(0, 56));
    margin-bottom: vw(70);
  }
}

.title {
  font-size: vwX(36);
  letter-spacing: vwX(PsdLetterSpacing(400, 36));
  margin-bottom: vwX(24);

  @include tablet {
    font-size: vw(36);
    letter-spacing: vw(PsdLetterSpacing(400, 36));
    line-height: lineHeight(36, 60);
    margin-bottom: vw(68);
  }

  br {
    display: none;

    @include tablet {
      display: block;
    }
  }
}

.text {
  font-size: vwX(18);
  letter-spacing: vwX(PsdLetterSpacing(120, 18));
  line-height: 1.94;
  // margin-bottom: vwX(16);
  text-shadow: black 0.1em 0.1em 0.2em;

  &.pc {
    display: block;

    @include tablet {
      display: none;
    }
  }

  &.mb {
    display: none;

    @include tablet {
      display: block;
    }
  }

  @include tablet {
    font-size: vw(21);
    letter-spacing: vw(PsdLetterSpacing(120, 21));
    // margin-bottom: 0;
    line-height: 1.95;
  }
}

.wrapper {
  background: #fff;
  color: #fff;
  position: relative;
  text-align: center;

  @include tablet {}

  .kv-container {
    background-image: url(./assets/img/kv_bg.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    padding-top: vwX(102);

    @include tablet {
      background-image: url(./assets/img/kv_bg_mb.jpg);
      padding-top: vw(108);
    }
  }

  .concept-container {
    background-image: url(./assets/img/concept_bg.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    padding-top: vwX(80);

    @include tablet {
      background-image: url(./assets/img/concept_bg_mb.jpg);
      padding-top: vw(140);
    }

    .content-box {
      transform: translateY(30%);
      opacity: 0;
    }

    &.active {
      .content-box {
        transform: translateY(0);
        opacity: 1;
        transition: all ease 0.6s;
      }
    }
  }

  .tech-container {
    background-image: url(./assets/img/tech.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    padding-top: vwX(80);

    @include tablet {
      background-image: url(./assets/img/tech_bg_mb.jpg);
      padding-top: vw(80);
    }

    .content-box {
      transform: translateY(30%);
      opacity: 0;
    }

    &.active {
      .content-box {
        transform: translateY(0);
        opacity: 1;
        transition: all ease 0.6s;
      }
    }
  }

  .gallery-container {
    position: relative;
    background-image: url(./assets/img/gallery_bg.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    // padding-top: vwX(162);
    overflow-y: hidden;
    position: relative;

    &::before {
      position: absolute;
      width: 100%;
      height: 100%;
      content: '';
      display: block;
      background-color: rgba(#000, .25);
    }

    @include tablet {
      background-image: url(./assets/img/gallery_bg_mb.jpg);
      padding-top: vw(140);
    }

    .title {
      margin-bottom: vwX(12);

      @include tablet {
        margin-bottom: vw(40);
      }
    }

    .text {
      margin-bottom: vwX(68);

      @include tablet {
        margin-bottom: vw(221);
      }
    }

    .content-box {
      position: absolute;
      width: 100%;
      top: 10%;
      margin-top: vwX(108);
      // transform: translateY(10%);
      // transform: translate3d(0, 0, 0);
      opacity: 0;

      // min-height: vwX(960);
      // display: inline;
      @include tablet {
        // min-height: vw(1100);
        margin-top: vw(135);
      }
    }

    &.active {
      .content-box {
        top: 0%;
        // transform: translateY(0%);
        // transform: translate3d(0, 0, 0);
        opacity: 1;
        transition: all ease 0.5s;
      }
    }
  }

  // .promotion-container {
  //   background-image: url(./assets/img/promotion_bg.png);
  //   background-repeat: no-repeat;
  //   background-size: cover;
  //   padding-top: vwX(66);
  //   display: flex;
  //   justify-content: center;
  //   align-items: flex-start;
  //   @include tablet {
  //     background-image: url(./assets/img/promotion_bg_mb.png);
  //     padding-top: vw(257);
  //   }
  //   .video-wrap {
  //     position: relative;
  //     overflow-y: hidden;
  //     a {
  //       cursor: pointer;
  //     }
  //     video {
  //       // transform: translate3d(0,0,0);
  //       width: vwX(825);
  //       @include tablet {
  //         width: vw(673);
  //       }
  //     }
  //     .first-play-btn {
  //       display: block;
  //       position: absolute;
  //       width: vwX(89);
  //       height: vwX(89);
  //       background-image: url(./assets/img/play_btn_fixed.png);
  //       background-repeat: no-repeat;
  //       background-size: cover;
  //       top: 50%;
  //       left: 50%;
  //       transform: translate(-50%, -50%);
  //       @include tablet {
  //         width: vw(92);
  //         height: vw(92);
  //       }
  //     }
  //     .reply-btn {
  //       display: block;
  //       position: absolute;
  //       width: vwX(89);
  //       height: vwX(89);
  //       background-image: url(./assets/img/reply_icon.png);
  //       background-repeat: no-repeat;
  //       background-size: cover;
  //       top: 50%;
  //       left: 50%;
  //       transform: translate(-50%, -50%);
  //       &::before {
  //         content: "再次觀看";
  //         display: block;
  //         position: absolute;
  //         font-size: vwX(16);
  //         letter-spacing: vwX(PsdLetterSpacing(120, 16));
  //         width: vwX(120);
  //         text-align: center;
  //         left: 50%;
  //         transform: translateX(-50%);
  //         bottom: vwX(-40);
  //         color: #fff;
  //         @include tablet {
  //           font-size: vw(16);
  //           letter-spacing: vw(PsdLetterSpacing(120, 16));
  //           width: vw(120);
  //           bottom: vw(-40);
  //         }
  //       }
  //       @include tablet {
  //         width: vw(92);
  //         height: vw(92);
  //       }
  //     }
  //     .bottom-controller {
  //       position: absolute;
  //       padding: 0 vwX(44) vwX(24) vwX(44);
  //       bottom: 0;
  //       display: flex;
  //       justify-content: space-between;
  //       align-items: center;
  //       width: 100%;
  //       transform: translateY(0);
  //       transition: all ease 0.3s;
  //       @include tablet {
  //         padding: 0 vw(44) vw(24) vw(44);
  //       }
  //       .btn-group {
  //         display: flex;
  //         .play-btn {
  //           display: block;
  //           background-image: url(./assets/img/play_icon.png);
  //           background-repeat: no-repeat;
  //           background-size: cover;
  //           width: vwX(13);
  //           height: vwX(15);
  //           margin-right: vwX(20);
  //           @include tablet {
  //             width: vw(13);
  //             height: vw(15);
  //             margin-right: vw(20);
  //           }
  //         }
  //         .pause-btn {
  //           display: block;
  //           background-image: url(./assets/img/pause_icon.png);
  //           background-repeat: no-repeat;
  //           background-size: cover;
  //           width: vwX(9);
  //           height: vwX(15);
  //           @include tablet {
  //             width: vw(9);
  //             height: vw(15);
  //           }
  //         }
  //       }
  //       .time-group {
  //         display: flex;
  //       }
  //     }
  //     .bottom-controller.hide {
  //       transform: translateY(100%);
  //       transition: all ease 0.3s;
  //     }
  //   }
  // }
  .social-container {
    background-color: black;
    background-image: url(./assets/img/social_bg.png);
    background-repeat: no-repeat;
    background-size: cover;
    padding-top: vwX(135);

    @include tablet {
      padding-top: vw(45);
      min-height: vw(500) !important;
      background-image: url(./assets/img/social_bg_mb.jpg);
      // background-position: center center;
    }

    .social-media-wrap {
      display: flex;
      justify-content: center;
      transform: translateY(45%);
      opacity: 0;

      @include tablet {
        display: flex;
        padding: 0 vw(44);
        justify-content: space-between;
      }

      .social-content {
        margin: 0 vwX(22);
        color: #fff;

        @include tablet {
          display: flex;
          margin: 0;
          align-items: center;
        }

        img {
          width: vwX(68);
          margin-bottom: vwX(40);

          @include tablet {
            width: vw(68);
            height: vw(68);
            margin-bottom: vw(0);
            margin-right: vw(13);
          }
        }

        .social-text {
          font-size: vwX(18);
          letter-spacing: vwX(PsdLetterSpacing(60, 18));

          @include tablet {
            text-align: left;
            font-size: vw(18);
            letter-spacing: vw(PsdLetterSpacing(60, 18));
            line-height: lineHeight(18, 30);
          }

          br {
            display: none;

            @include tablet {
              display: block;
            }
          }
        }
      }
    }
  }

  .social-container.active {
    .social-media-wrap {
      transform: translateY(0%);
      opacity: 1;
      transition: all ease 0.6s;
    }
  }
}
</style>
